import React from 'react'
import { Route } from 'react-router-dom'
import NotFound from './NotFound';

const NotFoundRoute = [
  <Route
    key="NotFound"
    path={'*'}
    component={NotFound}
  />,
];

export default NotFoundRoute